import * as React from "react";
import {useCallback} from "react";
import {Product} from "../types";
import {stylesheet} from "typestyle";
import {Table, TableBody, TableCell, TableHead, TableRow} from "@variocube/cube-ui";
import {Inventory} from "../inventory";
import {useLocalization} from "../../i18n";

interface ProductsListProps {
    products: Product[];
    inventory: Inventory;
    onSelectProduct: (product: Product) => void;
}

export function ProductTable({products, inventory, onSelectProduct}: ProductsListProps) {
    const {t} = useLocalization();
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell align="left" className={styles.productCol}>{t("Product")}</TableCell>
                    <TableCell align="right">{t("Count")}</TableCell>
                    <TableCell align="right" className={styles.priceCol}>{t("Price")}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {products.map(product => (
                    <ProductTableRow
                        key={product.id}
                        onClick={onSelectProduct}
                        product={product}
                        inventory={inventory}
                    />
                ))}
            </TableBody>
        </Table>
    );
}

interface ProductTableRowProps {
    product: Product;
    inventory: Inventory;
    onClick: (product: Product) => void;
}

function ProductTableRow({product, inventory, onClick}: ProductTableRowProps) {
    const handleClick = useCallback(() => onClick(product), [onClick, product]);
    return (
        <TableRow onClick={handleClick}>
            <TableCell align="left">{product.name}</TableCell>
            <TableCell align="right">{inventory.getCount(product)}</TableCell>
            <TableCell align="right">€ {product.price.gross.toFixed(2)}</TableCell>
        </TableRow>
    )
}

const styles = stylesheet({
    productCol: {
        width: "70%",
    },
    priceCol: {
        width: "30%",
    },
});

